const TRANSMISSION_SUCCESS_MESSAGE = ' com sucesso, realize a consulta do retorno do evento em Visualização de envios.';

export const SINGLE_TRANSMISSION_MESSAGE = `Evento transmitido ${TRANSMISSION_SUCCESS_MESSAGE}`;

export const BATCH_TRANSMISSION_MESSAGE = `Eventos transmitidos ${TRANSMISSION_SUCCESS_MESSAGE}`;

export const ESOCIAL_DISABLED_STATUS = [{
  name: 'P',
  description: 'Pendente',
}, {
  name: 'D',
  description: 'Admissão - não sincronizado',
}, {
  name: 'R',
  description: 'Reintegração", "Reintegração',
}, {
  name: 'L',
  description: 'Alteração Pendente',
}];

export const ERROR_HELP_LINKS = [
  {
    code: '1801',
    description: 'O FAP do estabelecimento não foi localizado na base.',
    helpLink: 'https://ajuda.contaazul.com/hc/pt-br/articles/4737701558285-Erro-no-eSocial-O-FAP-do-estabelecimento-n%C3%A3o-foi-localizado-na-base',
  },
];
